import { PluginType, type IExportPlugin } from '@/version-types';
import { Layer } from './layer';
import { LayerHistory } from './layer-history';

export * from './plugins';
export * from './layer';
export * from './agent-canvas-scale';
export { HistoryType } from './type';

/**
 * 基础图层插件
 */
export const layerPlugin: IExportPlugin = {
    type: PluginType.EXTENSION,
    sort: 0,
    name: 'base-layer',
    createInstance({ identity }) {
        return [{ key: 'Layer', value: new Layer(identity) }];
    },
    createHistory({ identity }) {
        return [new LayerHistory(identity)];
    },
};
